import(/* webpackMode: "eager" */ "/home/ubuntu/routerbench_new/apps/ui/src/app/forgot-password/page.tsx");
